export default "__VITE_ASSET__DSj3L6Df__"